module.exports = __webpack_public_path__ + "img/logo_home.0c4eaed4.png";